import { Component, OnDestroy, OnInit } from '@angular/core';
import { MainLayoutStore } from '@layouts/main-layout';

import { Autocomplete, Button, Card, Input } from '@ntv360/component-pantry';
import { GoogleMapsComponent } from '@shared/components';
import { SVG_ICONS } from '@shared/constants';
import { ADVERTISER_PROFILE_FORM_FIELDS } from '../../constants';

/**
 * Component for creating a new advertiser profile.
 */
@Component({
    selector: 'app-create-advertiser-profile',
    imports: [Card, Input, Autocomplete, Button, GoogleMapsComponent],
    templateUrl: './create-advertiser-profile.component.html',
    styleUrl: './create-advertiser-profile.component.scss',
})
export class CreateAdvertiserProfileComponent implements OnInit, OnDestroy {
    /**
     * Reference to navbar icon constants.
     */
    public icons = SVG_ICONS;

    /**
     * Path to the SVG sprite file.
     */
    public spritePath = 'assets/icons/icons-sprite.svg';

    /**
     * Form configuration fields.
     */
    protected formFields = ADVERTISER_PROFILE_FORM_FIELDS;

    /**
     * State options for the map filter.
     */
    protected stateOptions = [
        { label: 'California', value: 'CA' },
        { label: 'Texas', value: 'TX' },
        { label: 'New York', value: 'NY' },
        { label: 'Florida', value: 'FL' },
        { label: 'Illinois', value: 'IL' },
    ];

    /**
     * Autocomplete config for the states filter.
     */
    protected stateConfig = {
        placeholder: 'All States',
        searchable: true,
        clearable: true,
    };

    /**
     * Initializes the component by setting the specific breadcrumb text.
     */
    ngOnInit(): void {
        /**
         * Updates the sub-navbar breadcrumb in a microtask
         * to ensure proper execution order.
         */
        queueMicrotask(() => {
            MainLayoutStore.setBreadcrumb('Create Advertiser Profile');
        });
    }

    /**
     * Cleans up the breadcrumb when the component is destroyed.
     */
    ngOnDestroy(): void {
        MainLayoutStore.clearBreadcrumb();
    }
}
